import { c as _c } from "react/compiler-runtime";
interface ThumbnailProps {
  url?: string | null;
  className?: string;
}

/**
 * Shows a newsletter card's thumbnail. Editors choose it on the newsletter signup group item.
 * Renders nothing when the card has no thumbnail.
 */
export const Thumbnail = t0 => {
  "use memo";

  const $ = _c(5);
  const {
    url,
    className
  } = t0;
  if (!url) {
    return null;
  }
  const t1 = `url(${url})`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      backgroundImage: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className || $[3] !== t2) {
    t3 = <div className={className} style={t2} />;
    $[2] = className;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};